import { format, Locale } from 'date-fns';
import { cs, de, enUS, fr, pl } from 'date-fns/locale';
import { AppLanguage, DateFormats } from '../enums';

const LOCALE_BY_LANG: Record<AppLanguage, Locale> = {
  [AppLanguage.pl]: pl,
  [AppLanguage.en]: enUS,
  [AppLanguage.de]: de,
  [AppLanguage.fr]: fr,
  [AppLanguage.cs]: cs
};

const localeHolder: { value: Locale } = { value: pl };

export const setActiveDateLocale = (language: AppLanguage): void => {
  localeHolder.value = LOCALE_BY_LANG[language] ?? pl;
};

export const getActiveDateLocale = (): Locale => localeHolder.value;

export const formatDateToString = (date: Date | string | number, specificFormat: DateFormats): string => {
  if (date === null || date === undefined) return '';
  return format(date, specificFormat, { locale: localeHolder.value });
};
